module.exports = __webpack_public_path__ + "static/media/BG_46.dfc28d3d.png";